var module = angular.module('octopusApp.library');

module.controller('CommunityStepTemplateUpdateController', function ($scope, $location, busy, octopusRepository, actionTemplate, communityStepTemplate, $uibModalInstance) {
    $scope.newActionName = actionTemplate.Name + ' Copy';
    $scope.newActionDescription = actionTemplate.Description;
    $scope.action = actionTemplate;
    $scope.communityStepTemplate = communityStepTemplate;

    $scope.close = function() {
        $uibModalInstance.dismiss();
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss();
    };

    $scope.showDetails = function() {
        $uibModalInstance.dismiss();
        $location.search('activeTab', null);
        $location.path("/library/steptemplates/community/" + $scope.action.Id + "/details").search("from", "communityupdate");
    };

    $scope.update = function() {
        var update = true;
        $uibModalInstance.close(update);
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/community_step_template_update_controller.js
// module id = 8010332526781934
// module chunks = 1